// extracted by mini-css-extract-plugin
export default {"button":"AddButton_button__2BlCs"};